import React from "react";
import "./feedbacks.css";
import msgAvatar from '../../assets/feedbacks/msg-avatar.png';
const testimonials = [
  {
    name: "Nethmi Perera",
    title: "2024 A/L",
    text: `"අයියේ මම වවන් කන method එක කරන්න පටන් ගත්තා .. ඇත්තටම ගොඩාක් වටින method එකක් මේක .Royal, Vishaka, Western, Wayamba, Rathanawali, Ananda, North central kiyana papers ටිකයි 2019,2020,2021 past papers ටිකයි තමයි මම select කරගත්තේ.. අයියේ මම 22, 23 මගේ 1st shy and 2 nd shy full විවරණ කරලා තියෙන්නෙ ඒ නිසා ඒ පේපර් දෙක මේකට ගත්තේ නෑ. එහෙම හොඳයි නේද අයියේ. තව අයියේ මම physics physics revision දැනට ඉගෙන ගත්ත පාඩම් වලිනුත් summaries හදන්න පටන් ගත්තා. මට shy දෙකේම අමාරුම subject එක වුනේ physics. ඒක අමාරු වෙන්න හේතුව මට තේරුම් ගියේ අයියගෙ videos ටික බලලා ඒ විදිහට වැඩ ටික කරන්න ගත්තාට පස්සෙ. මට ගොඩක් තිඛිල තියෙන්නෙ theory මතක නැති හා හරියට theory apply කරගන්න බැරි ගැටලුවක්. ඒකට හරියන්න වැඩ ටික කරගෙන යනවා.. ඇත්තටම ම ගොඩක් වාසනාවන්තයි කියල හිත... Read more 20:47 Message"`,
    image: "FAvatar.png",
    alt: "Profile picture of Peter Foh",
    screenshot: "4.jpg",
  },
  {
    name: "Dineth Gunawardena",
    title: "2024 A/L",
    text: `"රෑ 10 ට විතර class ඉවර වෙන දවසට, රෑට වැඩ කරන්න මහන්සි නිසා මං රෑ 2, 3 වෙනකම් වැඩ කරලා, ආයෙ 5.30ට ඇහැරිලා class යනවා අයියේ. ඇත්තටම මං මෙහෙම කරද්දි හැම වෙලාවෙම හිතන්නෙ මං මේ මහන්සි වෙන්නේ මගේ හීනෙටයි. ඉතින්, ඒ හීනෙට ගියාම මගේ ජීවිතේ මෙහෙම තමයි. රෑ දවල් නොබලා වැඩ කරන්න වෙනවා කියන එක ඔලුවෙ තියාගෙන තමයි මං වැඩ කරන්නේ.

1221 අයියලා දෙන්නගේ class එකත් මේ app එකත් නිසා මගේ study life එකේ ඇත්තටම ලොකු වෙනසක් වුණා. මේ app එකේ වැඩ කරද්දි on කරලා, whatsapp කාත් එක්ක msg කරන්නට ගියත් pause කරන්න පුළුවන්. එතකොට අපිට හරියටම අපි කොච්චර වැඩ කරාද කියලා දැනගන්න ලේසි වෙනවා.

12:23. මං ඇත්තටම අයියේ, 01 A6 B3 කාණ්ඩ විශයන් 3ටම B ගත්තා. Exam දවස් වල මට වුණ පොඩි පොඩි අවුල් කීපයක් නිසා ඒ subjects ටිකට අවුල් ගියා. අම්මලා වුණත්, නෑදෑයො වුණත්, මට A9 ගන්න කියලා බලාගෙන හිටියත්, මට ඒක කරන්න බැරි වුණ එකේ මං සෑහෙන්න මානසිකව down වුණා."`,
    image: "MAvatar.png",
    alt: "2024 A/L",
    screenshot: "5.jpg",
  },
  {
    name: "Tharushi Wijesinghe",
    title: "2024 A/L",
    text: `"මේ ක්ලාස් එක හම්බෙලා A/L හරි විදියට කරන කාර්යය මාර්ගය දැනගෙන, ඒ අනුව වැඩ කරගෙන යන්න ලැබුණ එක ගැන ගොඩක් ගෞරවයෙන් කියන්න ඕනේ. මම මගේ 3rd shy කරනවා කියලා කිව්ව යාළුවන්ටත් ක්ලාස් එක ගැන කියලා ගැම්මක් ගත්තා. මට දැන් subject 3ක් ගමන්ම හරිම ආසාවෙන් කරන්න පුළුවන්.

ගොඩක් ස්තුතියි අයියලා දෙන්නාටත් සහ instructors ලා හැමෝටම! ඒ වගේම අයියේ essays ගැනත් කියන්නම ඕනේ. මම May වල join උනේ. Join උන දවසෙ ඉඳලාම හැමදාම sketch ගැහුවා, essays ලිව්වා, revise කරා. මේ වැඩපිළිවෙළ නිසා මට මම ගැන තිබුණු විශ්වාසය තවත් වැඩි වුණා.

ඉස්සර මට මතක හිටින්නෙම නැති කරුණු, දැන් revise කරනකොට ටක් ගාලා මතක් වෙනකොට ලොකු ගැම්මක් එනවා. ඒක නිසා තවත් වැඩ කරන්න drive එකක් ලැබුණා. Shy 3ක් exam කරන එක කියන්නෙම ගොඩක් මහන්සි වැඩක්නේ, ඒ වුණත් මට ආසවෙන්ම මේ අවුරුද්දේ A/L කරන්න පුළුවන් කියලා කියන්නයි තියෙන්නේ.

මං මෙච්චර දවසක් feedback මොකුත්ම දැම්මෙම නෑ. ඒත් අද පොඩි වෙලාවක් අරගෙන, මේ වචන ටික type කරන්න හිතුනා. Once again, Thank you!.

Once again Thank you ❤️`,
    image: "FAvatar.png",
    alt: "Profile picture of Rene Wells",
    screenshot: "6.jpg",
  },
  {
    name: "Janith Ekanayake",
    title: "2024 A/L",
    text: `"වරදින වරදින හැම point එකක් ගැනත් මෙක මෙහෙම එන්න ඕනේ කියලා කියලා කියනවා. Bio ගැන එපා වෙලා ඉන්න මට්ටමක ඉන්න කෙනෙක්ට, මම highly recommend කරන එකම Bio class එක Sir ලා දෙන්නගෙ class විතරමයි. "`,
    image: "MAvatar.png",
    alt: "Profile picture of Alex Badejo",
    screenshot: "1.jpg",
  },
  {
    name: "Hasini Ratnayake",
    title: "2024 A/L",
    text: `"ඒත් දැන් මට මේක කෝමහරි first shy ම කරලා ඉවර කරගන්න ඕනී කියන එක ඔලුවේ තියෙනවා අයියේ මං ඒ වෙනුවෙන් උපරිම මහන්සි වෙනවා.... මං විශ්වාස කරනවා දැනට BCS වගේ result එකක ඉන්න මට AAA මේ මාස 4 න් කොහොමහරි හදාගන්න පුළුවන් වෙයි කියලා"`,
    image: "FAvatar.png",
    alt: "Profile picture of Rachel Wright",
    screenshot: "2.jpg",
  },
  {
    name: "Kavindu Bandara",
    title: "2024 A/L",
    text: `"මේ අයියේ clz එකට join වෙන්න කලින් මගේ ලකුණු range එක තමා නිල් පාටින් තියෙන්නේ...... ඒත් දැන් මේ සති 4 ට ලකුණු වැඩි වුණ හැටි මෙතන මේ ලකුනු 7/15 paper එකයි 18 paper එකයි 16, 17 මං ලිව්වේ නෑ... මේක ලොකු ලකුණක් නොවුණට මං හිටිය විදිහට ගොඩක් සතුටුයි අයියේ..... අනික මට මේ 16 තිබ්බ එකේ ලකුනු 22 ඉදන් 25 ළමයිව stage ගෙන්නුවේ..... අපේ revision එකේ daily උදේට කරන mcq paper එක"`,
    image: "MAvatar.png",
    alt: "Profile picture of Zahir Mays",
    screenshot: "3.jpg",
  },
  
  {
    name: "Ishan Pathirana",
    title: "2024 A/L",
    text: `"Ayiyee mee thiyenne mn ඇති කනන ගත්ත පලවෙනි paper eka mn bio witharak nathuwa ayiyala kiwwa wage subject 3tama eka kara ekak iwara karanna sathi 2k wage giya ee unata aththatama ee wade maru mata habavechcha samahara prashna eheman enna pulkiyala hithichcha ewath thibba 🤔

Time table eka kiyala mm liyala haduwe na ayiye mata welawa bedala karanna gaththa kisima welawaka ee wade ee welawata wenne nathi nisa ee unata mn aniwaryen dawasata පැමි 3 gane watenna session 5 kata welawa bedala wada kara class nathi dawasata class thiyena dawasata paya 3 gane welawa watena widiyata session kadala wada kara hama session ekatama warayak iwara wela winadi 30 k withara nikan idala apahu wada karanna gaththa.

Ayiyalage plan ekath ekkama wada kerena nisa mata giya maseta wada yamak mee mase weddi puluwan 👍😁 Thank you ayiyee."`,
    image: "MAvatar.png",
    alt: "Profile picture of Alec Whitten",
    screenshot: "7.jpg",
  },
  {
    name: "Ramishka Geenath",
    title: "2024 A/L",
    text: `"මේ class එක join වෙන්න කලින් මගේ ලකුණු range එකත් තාම අඩුමට්ටමක හිටියද, අයියලාගේ class එක නිසා සෑහෙන ප්‍රගතියක් දකින්න පුළුවන් වුණා. මේ ලකුණු නම් ඒකට පේරාගන්න සාක්ෂියක්! 😊🙏

Bio O/L විතරයි ඉගෙන ගත්තාට, ඔයාලගෙ essay programme එකට join වෙලා, C level එකට වත් යන්න උත්සහ කරන්න ලොකු විශ්වාසයක් ගොඩනැගුණා. 4 පඳම cover කරලා, මම videos එකෙන් 5 වෙනි එකත් cover කරගෙන ගියා. අයියලාගේ මගපෙන්වීමේ සහාය එතරම්ම ලොකු වෙනසක් මගේ ජීවිතේට අරන් ආවා.

ස්තුතියි, අයියේ! ❤️🙏"`,
    image: "MAvatar.png",
    alt: "Profile picture of Eva Bond",
    screenshot: "8.jpg",
  },
  {
    name: "Sanduni Jayawardena",
    title: "2024 A/L",
    text: `"අයියේ කොච්චර කල් යයිද දන්නේ නෑ මේ පෙපර් සෙට් එක වවන් කාලා ඉවර කරනකොට.හැබැයි ඒක කරගෙන යනකොට ආස හිතෙනවා.මන් අද පටන් ගත්තේ.එක පේපර් එකක විභාජනය ප්‍ර‍්නේ.අනූනයයි අනූනනයි බලලා.ඉතිරි පේපර් ඔක්කොගෙමයි කරලා.පේසුරු ටිකත් කරා.තව වැදගත් ඒවා අර පොතේ ලියාගත්තා.අද පොඩි ශෝට් නෝට් එකක් ගහගත්තා.සාරංශ කරලා...එක ප්‍රශ්නයයි වුනත් කරේ ඒත් දැන් ඒකේන් ඕනම විදියකට ඇහුවත් උත්තර දෙන්න පුලුවන් වගේ දෙයක් දැනෙනවා.ගොඩක් තැන්ක්ස්.මෙහෙම අනිත් සබ්ජෙක්ට් වලටත් කරන්නම් නේද අයියා"`,
    image: "FAvatar.png",
    alt: "Profile picture of Candice Wu",
    screenshot: "9.jpg",
  },
];

function Feedbacks() {
  const [showMore, setShowMore] = React.useState(false);

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };
  return (
    <div className="z-0 flex flex-col items-center justify-center">
      <div className=" max-w-screen-lg text-myDark p-">
        <section className=" px-4   fade-in">
        <h1 className="  flex justify-center  text-2xl md:text-4xl text-center text-myBlue font-semibold">Valuable Feedbacks from Our Students</h1>
          {/* <h2 className="text-3xl font-bold text-center mb-4">
            What our users say
          </h2> */}
          <p className="text-center mb-8 opacity-25 text-center mx-3">
          Discover what our students are saying about their experience with ALGuidance.lk
          </p>
          <br />
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {testimonials.slice(0, 3).map((testimonial, index) => (
              <div
                key={index}
                className="bg-white p-4 rounded-lg shadow-md testimonial-card relative"
              >
                <div className="flex items-center mb-4">
                  <img
                    src={testimonial.image}
                    alt={testimonial.alt}
                    className="w-12 h-12 rounded-full mr-4"
                  />
                  <div>
                    <h3 className="font-bold text-left">{testimonial.name}</h3>
                    <p className="text-xs text-left opacity-50">{testimonial.title}</p>
                  </div>
                </div>
                <p className="text-sm text-justify">{testimonial.text}</p>
                <img
                  src={testimonial.screenshot}
                  alt={`Screenshot of review by ${testimonial.name}`}
                  className="  absolute top-0 left-0 w-full h-full object-cover opacity-0 hover:opacity-100 transition-opacity duration-300"
                />
              </div>
            ))}
          </div>
          <div
            className={`show-more-container ${
              showMore ? "expanded" : "collapsed"
            }`}
          >
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
              {testimonials.slice(3).map((testimonial, index) => (
                <div
                  key={index}
                  className="bg-white p-4 rounded-lg shadow-md testimonial-card relative"
                >
                  <div className="flex items-center mb-4">
                    <img
                      src={testimonial.image}
                      alt={testimonial.alt}
                      className="w-12 h-12 rounded-full mr-4"
                    />
                    <div>
                      <h3 className="font-bold text-left">{testimonial.name}</h3>
                      <p className="text-xs text-left opacity-50">{testimonial.title}</p>
                    </div>
                  </div>
                  <p className="text-sm">{testimonial.text}</p>
                  <img
                    src={testimonial.screenshot}
                    alt={`Screenshot of review by ${testimonial.name}`}
                    className="absolute top-0 left-0 w-full h-full object-cover opacity-0 hover:opacity-100 transition-opacity duration-300"
                  />
                </div>
              ))}
            </div>
          </div>
          <div className="text-center mt-4">
            <button className="text-myDim hover:underline" onClick={toggleShowMore}>
              {showMore ? "Show less" : "Show more"}
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}

export default Feedbacks;
